<template>
  <div class="top-bar">
    <span class="trigger-btn" @click="toggleCollapse">
      <MenuFoldOutlined v-if="!isCollapsed" />
      <MenuUnfoldOutlined v-else />
    </span>
    <a-breadcrumb class="top-breadcrumb">
      <a-breadcrumb-item>{{ breadcrumbTitle }}</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="top-right">
      <a-dropdown :trigger="['click']">
        <div class="user-info">
          <a-avatar :size="32" style="background-color: #1677ff;">
            <template #icon>
              <UserOutlined />
            </template>
          </a-avatar>
          <span class="user-name">{{ displayName }}</span>
          <DownOutlined />
        </div>
        <template #overlay>
          <a-menu>
            <a-menu-item key="profile" @click="navigateTo('/')">
              <UserOutlined /> 个人资料
            </a-menu-item>
            <a-menu-item key="log" @click="navigateTo('/userLog')">
              <FileTextOutlined /> 用户日志
            </a-menu-item>
            <a-menu-item key="key" @click="navigateTo('/dockKey')">
              <KeyOutlined /> 对接密钥
            </a-menu-item>
            <a-menu-divider />
            <a-menu-item key="logout" @click="outLogin">
              <LogoutOutlined /> 退出登录
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue';
import { message, Modal } from 'ant-design-vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  DownOutlined,
  FileTextOutlined,
  KeyOutlined,
  LogoutOutlined,
} from '@ant-design/icons-vue';

const route = useRoute();
const router = useRouter();
const store = useStore();

const user_conf = ref(JSON.parse(localStorage.getItem('user_conf') || '{}'));

// 初始化：优先从 localStorage 读取折叠状态，PC 端默认展开
const savedCollapse = localStorage.getItem('isCollapse');
if (savedCollapse !== null) {
  store.commit('setIsCollapse', parseInt(savedCollapse));
} else {
  store.commit('setIsCollapse', 1); // PC 端默认展开
}

const isCollapsed = computed(() => store.getters.isCollapse == 0 || store.getters.isCollapse == -1);

const displayName = computed(() => {
  if (user_conf.value.username) return user_conf.value.username;
  if (user_conf.value.user_email) return user_conf.value.user_email;
  return '未登录';
});

// 路由标题映射
const titleMap: Record<string, string> = {
  '/console': '控制台',
  '/userLog': '用户日志',
  '/dockKey': '接口密钥',
  '/withdrawal': '提现记录',
  '/agentEmpower': '代理中心',
  '/userManage': '用户管理',
  '/withdrawalManage': '提现管理',
  '/includesList': '软件列表',
  '/develop': '开发总览',
  '/productManage': '产品管理',
  '/VersionLog': '版本管理',
  '/NoticeManage': '公告管理',
  '/DataManage': '数据管理',
  '/CarmineList': '卡密列表',
  '/CarmineUse': '使用卡密',
  '/freeBenefits': '免费授权',
  '/query': '授权查询',
};

const breadcrumbTitle = computed(() => titleMap[route.path] || '页面');

const toggleCollapse = () => {
  const newVal = isCollapsed.value ? 1 : 0;
  store.commit('setIsCollapse', newVal);
  localStorage.setItem('isCollapse', String(newVal));
};

const navigateTo = (path: string) => {
  router.push(path);
};

const outLogin = () => {
  Modal.confirm({
    title: '确认退出',
    content: '您确定要退出登录吗？',
    okText: '确认',
    cancelText: '取消',
    okButtonProps: { danger: false },
    onOk: () => {
      localStorage.removeItem('token');
      localStorage.removeItem('user_conf');
      message.success('退出登录成功');
      setTimeout(() => { location.reload(); }, 1000);
    },
  });
};
</script>

<style scoped lang="scss">
.top-bar {
  height: 56px;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 20px;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  gap: 16px;

  .trigger-btn {
    font-size: 18px;
    cursor: pointer;
    padding: 6px;
    border-radius: 6px;
    color: #595959;
    transition: all 0.2s;
    display: flex;
    align-items: center;

    &:hover {
      background: #f0f5ff;
      color: #1677ff;
    }
  }

  .top-breadcrumb {
    flex: 1;
    font-size: 14px;
    color: #262626;
  }

  .top-right {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .user-info {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    padding: 4px 12px;
    border-radius: 20px;
    transition: all 0.2s;

    &:hover {
      background: #f5f5f5;
    }

    .user-name {
      font-size: 14px;
      color: #262626;
      max-width: 120px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
